import { Component, OnInit, Signal, inject, signal } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { GS1LoadingComponent, GS1LoadingService, GS1ModalModule, GS1ModalService } from '@gs1france/gs1-components-library';
import { CompanyService } from '@services/company.service';
import { OnboardingService } from '@services/onboarding.service';
import { PostLoginNavigationService } from '@services/post-login-navigation.service';
import { StorageService } from '@services/storage.service';
import { OAuthService } from 'angular-oauth2-oidc';
import { switchMap, tap } from 'rxjs';
import { AccessDataFromToken } from '../../models/access-data-from-token.model';
import { FooterComponent } from '../footer/footer.component';
import { HeaderComponent } from '../header/header.component';
import { PageComponent } from '../page/page.component';
import { SideMenuComponent } from '../side-menu/side-menu.component';

@Component({
  selector: 'connect',
  templateUrl: './connect.component.html',
  imports: [RouterOutlet, GS1LoadingComponent, GS1ModalModule, HeaderComponent, FooterComponent, PageComponent, SideMenuComponent],
  providers: [GS1ModalService, OnboardingService]
})
export class ConnectComponent implements OnInit {
  private router = inject(Router);
  private oauthService = inject(OAuthService);

  private loadingService = inject(GS1LoadingService);

  private storageService = inject(StorageService);
  private companyService = inject(CompanyService);
  private onboardingService = inject(OnboardingService);
  private postLoginNavigationService = inject(PostLoginNavigationService);

  accessData: Signal<AccessDataFromToken | null> = signal(this.storageService.getAccessDataFromToken());
  isFederation = signal(false);
  inscriptionComplete = signal(false);

  ngOnInit() {
    this.loadingService.startLoading('connect');
    this.companyService.getCompany().subscribe();

    this.storageService
      .getUser()
      .pipe(
        switchMap(() => this.storageService.isUserFederation()),
        tap((isFederation) => this.isFederation.set(isFederation)),
        tap(() => {
          if (this.accessData()) {
            this.inscriptionComplete.set(this.postLoginNavigationService.isInscriptionComplete(this.accessData(), this.storageService.userValue));

            if (this.inscriptionComplete()) this.initSession();
            else {
              this.loadingService.stopLoading('connect');
              this.storageService.isRedirected = true;
              this.router.navigate(['/formulaire-inscription', this.accessData().companyId]);
            }
          } else {
            this.loadingService.stopLoading('connect');
            this.storageService.clearStorage();
            this.oauthService.logOut();
          }
        })
      )
      .subscribe();
  }

  async initSession(): Promise<void> {
    try {
      const target = this.postLoginNavigationService.resolveInitialRoute(this.accessData());

      if (target) {
        const navigationSucceeded = 'url' in target ? await this.router.navigateByUrl(target.url) : await this.router.navigate(target.commands);

        if (!navigationSucceeded) throw new Error('Initial navigation was not successful');
      }
      this.onboardingService.open();
    } catch (error) {
      console.error('Error during session initialization:', error);
      await this.router.navigate(['/unauthorizedContact', String(error)]);
    } finally {
      this.loadingService.stopLoading('connect');
    }
  }

}
